import { FaCheckCircle, FaShoppingBag, FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./OrderSuccess.css";

function OrderSuccess() {

  const navigate = useNavigate();

  return (

    <section className="success-page">

      <div className="success-card">

        <div className="success-icon">
          <FaCheckCircle />
        </div>

        <h1>Thank You!</h1>

        <h3>Your Order Has Been Placed Successfully</h3>

        <p>
          We have received your order and it is now being processed.
          Our team will contact you shortly regarding delivery.
        </p>

        <div className="success-buttons">

          <button
            className="continue-btn"
            onClick={() => navigate("/")}
          >
            <FaHome />
            Continue Shopping
          </button>

          <button
            className="orders-btn"
            onClick={() => navigate("/orders")}
          >
            <FaShoppingBag />
            View Orders
          </button>

        </div>

      </div>

    </section>

  );

}

export default OrderSuccess;